<template>
  <v-app-bar id="default-app-bar" app absolute class="v-bar--underline" :color="barcolor">
    <v-tooltip bottom color="warning">
      <template v-slot:activator="{ on, attrs }">
        <v-app-bar-nav-icon v-bind="attrs" v-on="on" @click="mini = !mini" v-if="isLogin" :color="otherpropcolor" />
      </template>
      <span>Menu</span>
    </v-tooltip>
    <v-tooltip bottom color="warning">
      <template v-slot:activator="{ on, attrs }">

        <v-img v-bind="attrs" v-on="on" :max-width="$vuetify.breakpoint.mdAndUp ? 280 : 210"
          src="../../assets/UT logo blue.jpg" @click="logoClick" v-if="isReverse" style="cursor:pointer;"></v-img>
        <v-img v-bind="attrs" v-on="on" :max-width="$vuetify.breakpoint.mdAndUp ? 280 : 210"
          src="../../assets/UT logo full.jpg" @click="logoClick" v-if="isReverse === false"
          style="cursor:pointer;"></v-img>
      </template>
      <span>Dashboard</span>
    </v-tooltip>
    <v-spacer />

    <v-spacer />
    <v-switch dense v-model="switchtheme" label="Blue Theme" :color="otherpropcolor" v-show="false"
      :dark="isReverse"></v-switch>
    <v-tooltip bottom color="warning">
      <template v-slot:activator="{ on, attrs }">
        <v-img v-bind="attrs" v-on="on" :max-width="$vuetify.breakpoint.mdAndUp ? 60 : 60" src="../../assets/logo2.jpg"
          @click="openUdan" style="cursor:pointer;"></v-img>
      </template>
      <span>Online Testing</span>
    </v-tooltip>

    <default-account v-if="isLogin" />
  </v-app-bar>
</template>

<script>
// Utilities
import { get, sync } from "vuex-pathify";

export default {
  name: "DefaultBar",

  components: {
    DefaultAccount: () =>
      import(
        /* webpackChunkName: "default-account" */
        "./widgets/Account"
      ),
  },
  data: () => ({
    switchtheme: false,
    otherpropcolor: "primary",
    barcolor: "white",
    isLogin: false,
  }),
  mounted() {
    if (localStorage.getItem("user") || false) {
      this.isLogin = true;
    }
  },
  computed: {
    ...sync("app", ["drawer", "mini", "isReverse", "beta"]),
    name: get("route/name"),
  },
  watch: {
    isReverse: function (value) {
      if (value) {
        this.barcolor = "primary";
        this.otherpropcolor = "white";
      } else {
        this.barcolor = "white";
        this.otherpropcolor = "primary";
      }
    },
    switchtheme: function (value) {
      this.isReverse = value;
    },
  },
  methods: {
    openUdan() {
      window.open("https://utudaan.universaltutorials.in/");
    },
    logoClick() {
      this.$router.replace({ name: "Dashboard" });
    },
  },
};
</script>
